import { QCImpact, QCLabel } from 'interfaces/qcMarkers';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';

export const getQCLabelOptions = () => {
  return apiRequestHandlerPromise<QCLabel[]>({
    url: `qc_labels.get`,
    method: 'GET',
  });
};

export const getQCImpactOptions = () => {
  return apiRequestHandlerPromise<QCImpact[]>({
    url: `qc_impacts.get`,
    method: 'GET',
  });
};
